import {isDebugModeEnabled} from "@/app/Features";

export default function(options) {
    if (isDebugModeEnabled()) return options.fn(this);
    return options.inverse(this);
}
